import { WorkLogsQueryParams } from '@adminServices';
import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AdminCreateWorkLogDto, ApproveWorkLogDto, RejectWorkLogDto, UpdateWorkLogDto } from '@klubovna/api-client';
import { Store } from '@ngrx/store';
import * as WorkLogsActions from './work-logs.actions';
import * as WorkLogsSelectors from './work-logs.selectors';

@Injectable({
  providedIn: 'root',
})
export class WorkLogsFacade {
  private store = inject(Store);

  workLogs$ = this.store.select(WorkLogsSelectors.selectAllWorkLogs);
  loading$ = this.store.select(WorkLogsSelectors.selectWorkLogsLoading);
  error$ = this.store.select(WorkLogsSelectors.selectWorkLogsError);
  pagination$ = this.store.select(WorkLogsSelectors.selectWorkLogsPagination);
  pendingWorkLogs$ = this.store.select(WorkLogsSelectors.selectPendingWorkLogs);

  workLogs = toSignal(this.workLogs$, { initialValue: [] });
  loading = toSignal(this.loading$, { initialValue: false });

  loadWorkLogs(params?: WorkLogsQueryParams): void {
    this.store.dispatch(WorkLogsActions.loadWorkLogs({ params }));
  }

  adminCreateWorkLog(workLogData: AdminCreateWorkLogDto): void {
    this.store.dispatch(WorkLogsActions.adminCreateWorkLog({ workLogData }));
  }

  approveWorkLog(id: string, approveData: ApproveWorkLogDto): void {
    this.store.dispatch(WorkLogsActions.approveWorkLog({ id, approveData }));
  }

  rejectWorkLog(id: string, rejectData: RejectWorkLogDto): void {
    this.store.dispatch(WorkLogsActions.rejectWorkLog({ id, rejectData }));
  }

  updateWorkLog(id: string, updateData: UpdateWorkLogDto): void {
    this.store.dispatch(WorkLogsActions.updateWorkLog({ id, updateData }));
  }

  deleteWorkLog(id: string): void {
    this.store.dispatch(WorkLogsActions.deleteWorkLog({ id }));
  }
}
